import React from 'react';
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
} from 'cdbreact';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'scroll initial' }}>
      <CDBSidebar textColor="#fff" backgroundColor="#333">
        <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>}>
            Sidebar
        </CDBSidebarHeader>

        <CDBSidebarContent className="sidebar-content">
          <CDBSidebarMenu>
            <NavLink exact to="/admin/dashboard" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="columns">Article List</CDBSidebarMenuItem>
            </NavLink>
            <NavLink exact to="/admin/image-list" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="columns">Image List</CDBSidebarMenuItem>
            </NavLink>
            <NavLink exact to="/admin/create-article" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="table">Add Article</CDBSidebarMenuItem>
            </NavLink>
          </CDBSidebarMenu>
        </CDBSidebarContent>
      </CDBSidebar>
    </div>
  );
};

export default Sidebar;